import { Outlet } from 'react-router-dom';
import { AlertTriangle, PackageX } from 'lucide-react';
import { EmptyState } from '../../shared/ui/EmptyState';
import type { ModuleKey } from '../../shared/types/license';
import { useLicense } from './useLicense';
import styles from '../auth/PasswordExpiringBanner.module.css';

const MODULE_NAME: Record<ModuleKey, string> = {
  laudos: 'O módulo de laudos', agenda: 'A agenda', worklist: 'A worklist', whatsapp: 'O WhatsApp',
  chatbot: 'O chatbot', lista_espera: 'A lista de espera', financeiro: 'O financeiro',
};

export function RequireModule({ module }: { module: ModuleKey }) {
  const { canUse, canWrite, enforced, clinicReadOnly } = useLicense();
  // Carregando = fail-open (o servidor aplica de qualquer forma); evita spinner na GAIA.
  if (!canUse(module)) {
    return (
      <EmptyState
        icon={<PackageX size={48} />}
        title="Fora do plano da clínica"
        description="Este recurso não faz parte do plano contratado."
      />
    );
  }
  // Módulo que a clínica já teve e saiu do plano: os botões de gravar somem; sem esta faixa parece defeito.
  // Clínica inteira em só leitura já tem a faixa dela (LicenseReadOnlyBanner).
  if (enforced && !clinicReadOnly && !canWrite(module)) {
    return (
      <>
        <div className={styles.banner} role="status">
          <span className={styles.icon}><AlertTriangle size={18} aria-hidden="true" /></span>
          <p className={styles.text}>{MODULE_NAME[module]} está em só leitura no plano da clínica: dá para consultar, mas não alterar.</p>
        </div>
        <Outlet />
      </>
    );
  }
  return <Outlet />;
}
